import { Component, inject, computed, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterModule, ActivatedRoute, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { Header } from '../../components/user-dashboard-component/header/header';
import { Footer } from '../../components/user-dashboard-component/footer/footer';
import { UserSidebar } from '../../components/user-dashboard-component/user-sidebar/user-sidebar';
import { PageHeader } from '../../components/admin-dashboard-component/page-header/page-header';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-user-dashboard',
  imports: [RouterModule, RouterOutlet, Header, Footer, UserSidebar, PageHeader, NgClass],
  templateUrl: './user-dashboard.html',
  styleUrl: './user-dashboard.scss',
})
export class UserDashboard implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  private currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.url),
    ),
    { initialValue: this.router.url },
  );

  showSidebar = computed(() => this.currentUrl()?.includes('/user') ?? false);
  isSidebarCollapsed = false;
  currentPageTitle = 'Dashboard';
  currentPageUrl = '/user';
  breadcrumbs: { label: string; url: string }[] = [];

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.updateBreadcrumbs();
    });
    setTimeout(() => this.updateBreadcrumbs());
  }

  private updateBreadcrumbs() {
    let route = this.activatedRoute.root;
    let url = '';
    const breadcrumbs: Array<{ label: string; url: string }> = [];
    while (route.children.length > 0) {
      route = route.children[0];
      const routeConfig = route.snapshot.routeConfig;
      if (!routeConfig) continue;
      if (routeConfig.path) {
        url += `/${routeConfig.path}`;
        const params = route.snapshot.params;
        Object.keys(params).forEach((key) => {
          url = url.replace(`:${key}`, params[key]);
        });
      }
      if (route.snapshot.data['breadcrumb']) {
        breadcrumbs.push({
          label: route.snapshot.data['breadcrumb'],
          url: url,
        });
      }
    }
    const dedupedBreadcrumbs: Array<{ label: string; url: string }> = [];
    breadcrumbs.forEach((crumb, index) => {
      if (index == 0 || crumb.label != breadcrumbs[index - 1].label) {
        dedupedBreadcrumbs.push(crumb);
      }
    });
    if (dedupedBreadcrumbs.length > 0) {
      const lastBreadcrumb = dedupedBreadcrumbs[dedupedBreadcrumbs.length - 1];
      this.currentPageTitle = lastBreadcrumb.label;
      this.currentPageUrl = lastBreadcrumb.url;
      this.breadcrumbs = dedupedBreadcrumbs.slice(0, -1);
    } else {
      this.currentPageTitle = 'Dashboard';
      this.currentPageUrl = '/user';
      this.breadcrumbs = [];
    }
    if (this.currentPageUrl == '/user' || this.currentPageUrl == '') {
      this.breadcrumbs = [];
    }
  }

  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
}
